import { interviews } from "../../assets/text/interview";

const MobileInterviewScreen = ({ handleImageLink, toggle }) => {
  return (
    <div className="mobile-interview">
      {!toggle && (
        <div className="mobile-interview-arabic">
          {interviews.map((article) => {
            return (
              <div className="mobile-interview-arabic-container">
                <div className="mobile-interview-arabic-container-image">
                  <img
                    src={`/images/${article.image}`}
                    className="mobile-interview-arabic-container-image-img"
                    alt="Interview"
                  ></img>
                </div>
                <div className="mobile-interview-arabic-container-text">
                  <div
                    className="mobile-interview-arabic-container-text-title"
                    onClick={() => {
                      handleImageLink(true, article);
                    }}
                  >
                    {article.content.arabic.title}
                  </div>
                  <span className="mobile-interview-arabic-container-text-date">
                    {article.content.arabic.date}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {toggle && (
        <div className="mobile-interview-english">
          {interviews.map((article) => {
            return (
              <div className="mobile-interview-english-container">
                <div className="mobile-interview-english-container-image">
                  <img
                    src={`/images/${article.image}`}
                    className="mobile-interview-english-container-image-img"
                    alt="Interview"
                  ></img>
                </div>
                <div className="mobile-interview-english-container-text">
                  <div
                    className="mobile-interview-english-container-text-title"
                    onClick={() => {
                      handleImageLink(true, article);
                    }}
                  >
                    {article.content.english.title}
                  </div>
                  <span className="mobile-interview-english-container-text-date">
                    {article.content.english.date}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MobileInterviewScreen;
